<template>
  <div>
    <add-header @click="openEmergencyContactModal" id="emergency-contact-header" class="my-4">
      <template slot="title">
        <h2>Contato para Emergência</h2>
        <h3 class="text-secondary">Emergency Contacts</h3>
      </template>
    </add-header>
    <load-form-handler
      v-model="emergencyContacts"
      :promise="getEmergencyContacts">
      <template v-for="(emergencyContact, index) in emergencyContacts">
        <form-emergency-contact
          :key="emergencyContact.id+'emergency-contact'"
          :emergency_contact_attributes="emergencyContact"
          readonly
        />

        <v-layout row :key="index+'button-wrapper'" wrap justify-center>
          <v-btn
            color="primary" fab
            @click="openEmergencyContactModal(emergencyContact.id)"
            :key="index+'button-emergency-contact-edit'">
              <v-icon dark>edit</v-icon>
          </v-btn>

          <v-btn
            color="primary" fab
            @click="openAlertModal(emergencyContact.id, removeEmergencyContact)"
            :key="index+'button-emergency-contact-remove'">
              <v-icon dark>delete</v-icon>
          </v-btn>
        </v-layout>

        <v-divider
          :key="emergencyContact.id+'-divider-emergency-contact'"
          v-if="index !== (emergencyContacts.length -1)"
          class="my-4"
        />
      </template>
    </load-form-handler>

    <!-- emergency contact modal  -->
    <modal-form
      title="Contato de emergência / Emergency contact"
      :visibility="emergencyContactModalVisibility"
      @onClose="closeEmergencyContactModal"
      @onSave="handleSaveEmergencyContact"
      id="modal-form-emergency-contact">
        <form-emergency-contact
          ref="emergency_form"
          :emergency_contact_id="emergencyContactId"
          @emergency_contact_attributes="onEmergencyContactModal"
        />
    </modal-form>

    <alert-modal
      :visibility="alertModalVisibility"
      title="Excluir registro"
      message="Tem certeza que deseja excluir o registro?"
      confirmAction="OK"
      cancelAction="CANCELAR"
      @confirm="modalAction"
      @cancel="closeAlertModal"/>

  </div>
</template>

<script>
import FormEmergencyContact from './FormEmergencyContact'
import AddHeader from '@/components/AddHeader'
import ModalForm from '@/components/ModalForm'
import * as api from '@/api'
import LoadFormHandler from '@/components/LoadFormHandler'
import AlertModal from '@/components/AlertModal'
import { nestedForm, formTabs, message } from '@/mixins'

export default {
  name: 'NestedEmergencyContacts',

  mixins: [nestedForm, formTabs, message],

  data: () => ({
    emergencyContacts: [],
    emergencyContactId: null,
    emergencyContactModalVisibility: false
  }),

  components: {
    FormEmergencyContact,
    AddHeader,
    ModalForm,
    LoadFormHandler,
    AlertModal
  },

  methods: {
    // @vuese Método para obtencao da promise de contatos de emergencia
    getEmergencyContacts () {
      return api.emergencyContact.get(this.currentStudentId)
    },

    // @vuese Método para receber dados da modal de contato de emergencia
    async onEmergencyContactModal (emergencyContact) {
      try {
        if (this.emergencyContactId) {
          const { data } = await api.emergencyContact.update(this.currentStudentId, this.emergencyContactId, emergencyContact)
          this.emergencyContacts[this.emergencyContacts.findIndex(e => e.id === this.emergencyContactId)] = data
          this.$forceUpdate()
          this.showMessageByType(this.messageTypes.MODIFIED)
        } else {
          const { data } = await api.emergencyContact.create(this.currentStudentId, emergencyContact)
          this.emergencyContacts.push(data)
          this.showMessageByType(this.messageTypes.CREATED)
        }
      } catch (error) {
        this.handleErrorMessage(error)
      } finally {
        this.closeEmergencyContactModal()
      }
    },

    // @vuese Método para abertura da modal de contato de emergencia
    openEmergencyContactModal (id = null) {
      this.emergencyContactId = id
      this.emergencyContactModalVisibility = true
    },

    // @vuese Método para fechamento da modal de contato de emergencia
    closeEmergencyContactModal () {
      this.emergencyContactId = null
      this.emergencyContactModalVisibility = false
    },

    // @vuese Método para validação do novo contato de emergencia
    handleSaveEmergencyContact () {
      let formRef = this.$refs.emergency_form

      if (formRef.validateForm()) {
        formRef.save()
      }
    },

    // @vuese Método para remoção de contatos de emergência
    removeEmergencyContact (emergencyContactId) {
      api.emergencyContact.remove(this.currentStudentId, emergencyContactId)
        .then(() => {
          this.showMessageByType(this.messageTypes.REMOVAL)
          this.emergencyContacts.splice(this.emergencyContacts.findIndex(e => e.id === emergencyContactId), 1)
        })
        .catch(this.handleErrorMessage)
    }
  }
}
</script>
